
<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="l-simple-search-container">
        <el-form :model="search_data" label-width="60px" ref="form" label-position="left">
          <div class="input-with-select" style="display:inline-block;margin-right:10px">
            <el-select v-model="search_data.platform_type" @change="onSearch" placeholder="平台类型" clearable>
              <el-option label="管理平台" :value="1">
              </el-option>
              <el-option label="小程序" :value="2">
              </el-option>
            </el-select>
          </div>

          <div class="input-with-select" style="display:inline-block;margin-right:10px">
            <el-input placeholder="错误码" v-model="search_data.code" clearable>
            </el-input>
          </div>

          <div class="input-with-select" style="display:inline-block;margin-right:10px">
            <el-date-picker v-model="search_data.start_time" style="width:100%" type="datetime" @change="onSearch"
              value-format="yyyy-MM-dd HH:mm:ss" autocomplete="off" placeholder="开始时间">
            </el-date-picker>
          </div>
          <span style="display:inline-block;margin-right:10px">~</span>
          <div class="input-with-select" style="display:inline-block;margin-right:10px">
            <el-date-picker v-model="search_data.end_time" style="width:100%" type="datetime" @change="onSearch"
              value-format="yyyy-MM-dd HH:mm:ss" autocomplete="off" placeholder="结束时间">
            </el-date-picker>
          </div>
          <div class="input-with-select" style="display:inline-block;margin-right:10px">
            <el-input placeholder="方法/参数/错误信息/token" v-model="search_data.keywords" clearable>
            </el-input>
          </div>

          <el-button style="margin-left:10px" type="primary" @click="onSearch" icon="el-icon-search">搜索
          </el-button>
          <el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
        </el-form>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="platform_type" label="平台" min-width="140" show-overflow-tooltip>
        <template v-slot="{ row }">
          <el-tag v-show="row.platform_type == 1" type="success" size="mini">管理平台</el-tag>
          <el-tag v-show="row.platform_type == 2" type="warning" size="mini">小程序</el-tag>
        </template>

      </el-table-column>
      <el-table-column prop="url" label="请求地址" min-width="220" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="func" label="请求方法" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="params" label="请求参数" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="uid" label="UID" min-width="100" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="err_msg" label="错误信息" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="code" label="错误码" min-width="110" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="token" label="token" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="time" label="记录时间" min-width="180" show-overflow-tooltip fixed="right">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="130" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="logs_info_btn" @click="showInfo(row)"><i
              class="el-icon-warning-outline"></i>详情</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="详情" width="1200px">
      <l-logs-info :visible.sync="info_visible" :row="info_row" />
    </l-dialog>

  </el-card>
</template>

<script>
import Vue from "vue";
import Info from "./Info.vue";
export default {
  name: "l-logs",
  components: {
    [Info.name]: Info,
  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      info_visible: false, //是否显示编辑
      info_row: 0,

      //搜索
      search_visible: false,
      site_list: [],
      search_data: {
        keywords: "",
        code: "",
        start_time: "",
        end_time: "",
        platform_type: "",
      },
      rel_search_data: {},
      show_more_search: false,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("logs_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          // console.log(ret.data);
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //显示详情
    showInfo(row) {
      this.info_row = row;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //清除搜索数据
    clearSearch() {
      this.search_data.start_time = "";
      this.search_data.end_time = "";
      this.search_data.keywords = "";
      this.search_data.platform_type = "";
      this.search_data.code = "";
      this.getList();
    },
  },
};
</script>
